import { type ServiceMethod } from '@/application/interfaces/service';

export type Body = {
  cart_id: string;
  token: string;
  branded?: string;
  brand?: string;
};

export type Response = {
  data: {
    hashCard: string;
  };
};

export const verifyCreditCardToken: ServiceMethod<Response, Body> =
  (httpClient) => async (data, options) => {
    const { cart_id, token, brand, branded } = data;

    const { body: response } = await httpClient.post<Response, Body>(
      '/api/v3/credit-card/token/verify',
      {
        ...options,
        body: { cart_id, token, brand, branded },
      }
    );

    return response;
  };
